import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { AppStoreBadge, GooglePlaySoon } from './StoreButtons';

const Footer = () => (
  <footer className="bg-[#0b0f13] text-white border-t border-white/10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid md:grid-cols-4 gap-10 mb-10">
        <div className="col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img
              src="https://customer-assets.emergentagent.com/job_fishing-companion-4/artifacts/8tms506a_symbol.svg"
              alt="FlyFinder logo"
              className="h-10 w-auto"
            />
            <span className="text-2xl font-bold">FlyFinder</span>
          </div>
          <p className="text-slate-400 text-sm mb-4">
            The AI-powered fly fishing companion. Know what's hatching before you leave home.
          </p>
          <div className="flex flex-col gap-3">
            <AppStoreBadge className="h-12" />
            <GooglePlaySoon className="h-12" />
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2">
            <li><Link to="/" className="text-slate-400 hover:text-[#3aa0e0] transition-colors">Home</Link></li>
            <li><a href="/#features" className="text-slate-400 hover:text-[#3aa0e0] transition-colors">Features</a></li>
            <li><a href="/#pricing" className="text-slate-400 hover:text-[#3aa0e0] transition-colors">Pricing</a></li>
            <li><Link to="/fly-guide" className="text-slate-400 hover:text-[#3aa0e0] transition-colors">Fly Guide</Link></li>
            <li><Link to="/contact" className="text-slate-400 hover:text-[#3aa0e0] transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Legal</h3>
          <ul className="space-y-2">
            <li><Link to="/terms" className="text-slate-400 hover:text-[#3aa0e0] transition-colors">Terms of Service</Link></li>
            <li><Link to="/privacy" className="text-slate-400 hover:text-[#3aa0e0] transition-colors">Privacy Policy</Link></li>
            <li><Link to="/cookies" className="text-slate-400 hover:text-[#3aa0e0] transition-colors">Cookie Policy</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Contact</h3>
          <ul className="space-y-3 text-slate-400">
            <li className="flex items-start gap-2">
              <Mail className="w-5 h-5 text-[#3aa0e0] flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-semibold text-white text-sm">Support</p>
                <a href="mailto:info@flyfinder.ca" className="hover:text-[#3aa0e0] transition-colors text-sm">info@flyfinder.ca</a>
              </div>
            </li>
            <li>
              <p className="font-semibold text-white text-sm mb-1">FlyFinder Technologies Inc.</p>
              <p className="text-sm">Kingston, Ontario<br />Canada</p>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 pt-8 text-center text-slate-500 text-sm">
        <p>&copy; 2026 FlyFinder Technologies Inc. All rights reserved. Built for anglers across North America.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
